import NewsletterCTA from "../components/NewsletterCTA";

const QA = [
  {
    q: "What is a mass tort?",
    a: "A mass tort is a civil action involving many plaintiffs against one or a few corporate defendants—often related to a dangerous product, drug, or exposure.",
  },
  {
    q: "Do I pay any fees upfront?",
    a: "No. You pay nothing unless your attorney wins compensation for you. If there is a recovery, fees come from the final award/settlement.",
  },
  {
    q: "How long does a review take?",
    a: "Most initial reviews are fast—often the same day. If your case is likely eligible, the law firm will follow up to gather more details.",
  },
  {
    q: "Will my information be kept private?",
    a: "Yes. Submissions are confidential and shared only with participating law firms for evaluation. See our Privacy Policy for more.",
  },
];

export default function FAQs() {
  return (
    <main className="max-w-3xl mx-auto px-4 py-12">
      <header className="mb-6">
        <h1 className="text-3xl md:text-4xl font-extrabold text-[#0A2540]">FAQs</h1>
        <p className="mt-2 text-slate-700">Quick answers to the most common questions.</p>
      </header>

      <div className="space-y-3">
        {QA.map((item, idx) => (
          <details
            key={idx}
            className="group rounded-xl border border-slate-200 bg-white p-4 open:shadow-sm"
          >
            <summary className="flex cursor-pointer list-none items-center justify-between">
              <span className="font-semibold text-[#0A2540]">{item.q}</span>
              <svg
                className="h-5 w-5 text-slate-500 transition group-open:rotate-180"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            </summary>
            <p className="mt-2 text-slate-700">{item.a}</p>
          </details>
        ))}
      </div>

      {/* Optional subscribe box */}
      <NewsletterCTA />
    </main>
  );
}
